
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import Modal from "react-bootstrap/Modal";

interface SupportFormProps {
  show?: boolean;
  onShow?: () => void;
  onHide?: () => void;
}

export default function SupportForm({ show: controlledShow, onShow, onHide }: SupportFormProps) {
  const { t } = useTranslation('components.SupportForm');
  const [show, setShow] = useState(false);
  const isOpen = controlledShow ?? show;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://link.msgsndr.com/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const open = () => {
    if (onShow) {
      onShow();
      return;
    }
    setShow(true);
  };

  const close = () => {
    if (onHide) {
      onHide();
      return;
    }
    setShow(false);
  };

  return (
    <>
      <Modal centered show={isOpen} onHide={close} size="lg">
        <Modal.Header>
          <Modal.Title>
            <button onClick={close} className=" support-close ">
              {t('close')}
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: "580px",
            overflow: "auto",
          }}
        >
          <iframe
            src="https://api.leadconnectorhq.com/widget/form/M1pVAg4F9Bmyknmb8E6g"
            style={{
              width: "100%",
              height: "500px",
              border: "none",
              borderRadius: "3px",
            }}
            id="inline-M1pVAg4F9Bmyknmb8E6g"
            data-layout='{"id":"INLINE"}'
            data-trigger-type="alwaysShow"
            data-activation-type="alwaysActivated"
            data-deactivation-type="neverDeactivate"
            data-form-name="Support"
            data-form-id="M1pVAg4F9Bmyknmb8E6g"
            title="Support"
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
